export const LAST_SIGN_IN_TRACKING_STORAGE_KEY = 'last-sign-in-tracking-timestamp'
export const FIRST_LOGIN_ORIGIN_TRACKING_STORAGE_KEY = 'first-login-origin-tracked'
export const SIGNIN_TRACKING_INTERVAL = 24 * 60 * 60 * 1000 //in milliseconds (24h)
